export const REGISTER_SUCCESS_COUNT_DOWN = 3;
